export default __webpack_public_path__ + "our-target-group.png";